import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const AppConfig = Loadable(
	lazy(() => import('modules/AppConfiguration/pages/AppConfig')),
);

const IntroductionPhaseVideoConfig = Loadable(
	lazy(
		() => import('modules/AppConfiguration/pages/IntroductionPhaseVideoConfig'),
	),
);

const VerbLessonPronounsImageConfig = Loadable(
	lazy(
		() =>
			import('modules/AppConfiguration/pages/VerbLessonPronounsImageConfig'),
	),
);

const RegionsConfig = Loadable(
	lazy(() => import('modules/AppConfiguration/pages/RegionsConfig')),
);

const AppPlatformsVersionsConfig = Loadable(
	lazy(
		() => import('modules/AppConfiguration/pages/AppPlatformsVersionsConfig'),
	),
);

const NumberCombinationConfig = Loadable(
	lazy(() => import('modules/AppConfiguration/pages/NumberCombinationConfig')),
);

const TimeCombinationConfig = Loadable(
	lazy(() => import('modules/AppConfiguration/pages/TimeCombinationConfig')),
);

const APP_CONFIGURATION_ROUTES: IRoute[] = [
	{
		path: 'app-config',
		element: AppConfig,
		name: 'AppConfig',
		roles: [ROLES.ADMIN],
		private: true,
		children: [
			{
				path: 'introduction-phases',
				element: IntroductionPhaseVideoConfig,
				name: 'IntroductionPhaseVideoConfig',
				roles: [ROLES.ADMIN],
				private: true,
			},
			{
				path: 'verb-lesson-pronouns',
				element: VerbLessonPronounsImageConfig,
				name: 'VerbLessonPronounsImageConfig',
				roles: [ROLES.ADMIN],
				private: true,
			},
			{
				path: 'regions',
				element: RegionsConfig,
				name: 'RegionsConfig',
				roles: [ROLES.ADMIN],
				private: true,
			},
			{
				path: 'app-platforms-versions',
				element: AppPlatformsVersionsConfig,
				name: 'AppPlatformsVersionsConfig',
				roles: [ROLES.ADMIN],
				private: true,
			},
			{
				path: 'number-combination-config',
				element: NumberCombinationConfig,
				name: 'NumberCombinationConfig',
				roles: [ROLES.ADMIN],
				private: true,
			},
			{
				path: 'time-combination-config',
				element: TimeCombinationConfig,
				name: 'TimeCombinationConfig',
				roles: [ROLES.ADMIN],
				private: true,
			},
		],
	},
];

export default APP_CONFIGURATION_ROUTES;
